'use client';

import {useCallback, useState} from 'react';
import {useIsLargeAndUp} from '../../hooks/useMatchQuery';
import {ResetPasswordModal} from '../ResetPasswordModal';
import {SignUpModal} from '../SignUpModal/SignUpModal';
import {LoginContainer} from './LoginContainer';
import {appleConnect, googlePlusConnect} from './socialLogin';

const trackUserId = (userId, subscriptionPlanName, email) => {
  // biome-ignore lint/style/useNamingConvention: Fix me!
  window.dataLayer.push({user_identifier: userId});
  // biome-ignore lint/style/useNamingConvention: Fix me!
  window.dataLayer.push({is_logged_in: 1});
  // biome-ignore lint/style/useNamingConvention: Fix me!
  if (subscriptionPlanName) window.dataLayer.push({subscription_plan_name: subscriptionPlanName});
  window.dataLayer.push({email});
};

export const LoginWrapper = ({onSignupSuccess, onLoginSuccess, onCloser, isModal = true}) => {
  const isLargeAndUp = useIsLargeAndUp();
  const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
  const [signupOrLogin, setSignupOrLogin] = useState('login');
  const [passwordResetOpen, setPasswordResetOpen] = useState(false);

  const handlePwReset = useCallback(() => {
    setPasswordResetOpen(true);
  }, []);

  const handlePwResetClose = useCallback(() => {
    setPasswordResetOpen(false);
  }, []);

  const switchToLogin = useCallback(() => setSignupOrLogin('login'), []);
  const switchToSignup = useCallback(() => setSignupOrLogin('signup'), []);

  const onCloseHandler = useCallback(() => {
    onCloser();
    setTimeout(() => {
      setForgotPasswordMode(false);
      setSignupOrLogin('login');
    }, 600);
  }, [onCloser]);

  const onForgotPasswordClick = useCallback((e) => {
    e.preventDefault();
    setForgotPasswordMode(true);
  }, []);

  const onForgotPasswordCancel = useCallback((e) => {
    e.preventDefault();
    setForgotPasswordMode(false);
  }, []);

  const onSuccess = useCallback(
    (user) => {
      const successFunc = signupOrLogin === 'login' ? onLoginSuccess : onSignupSuccess;
      successFunc(
        user.user_id,
        user.full_name,
        user.subscription_plan_name,
        user.email,
        user.avatar_disk,
        user.image_url,
        user.initials,
        user.first_name,
        user.token
      );
      trackUserId(user.user_id, user.subscription_plan_name, user.email);
    },
    [signupOrLogin, onLoginSuccess, onSignupSuccess]
  );

  const onGoogleConnect = useCallback(
    async (e, marketingOptIn = true) => {
      e.preventDefault();
      try {
        const user = await googlePlusConnect(marketingOptIn);
        onSuccess(user);
      } catch (_error) {
        evite?.log('Google connect closed without logging in');
      }
    },
    [onSuccess]
  );

  const onAppleConnect = useCallback(
    async (e, marketingOptIn = true) => {
      e.preventDefault();
      try {
        const user = await appleConnect(marketingOptIn);
        onSuccess(user);
      } catch (_error) {
        evite?.log('Apple connect closed without logging in');
      }
    },
    [onSuccess]
  );

  return signupOrLogin === 'signup' ? (
    <SignUpModal
      isModal={isModal}
      lgWindow={isLargeAndUp}
      onSignInClick={switchToLogin}
      onCloseModal={onCloseHandler}
      privacyPolicyHref="/content/privacy_policy/"
      termsHref="/content/terms/"
      onSuccess={onSignupSuccess}
      onGoogleLoginClick={onGoogleConnect}
      onAppleLoginClick={onAppleConnect}
    />
  ) : (
    <>
      <LoginContainer
        isModal={isModal}
        onCreateAccountClick={switchToSignup}
        onCloseModal={onCloseHandler}
        onSuccess={onLoginSuccess}
        onGoogleLoginClick={onGoogleConnect}
        onAppleLoginClick={onAppleConnect}
        onForgotPasswordClick={onForgotPasswordClick}
        onForgotPasswordCancel={onForgotPasswordCancel}
        forgotPasswordMode={forgotPasswordMode}
        handlePwReset={handlePwReset}
      />
      {passwordResetOpen && (
        <ResetPasswordModal
          isOpen={passwordResetOpen}
          setIsOpen={setPasswordResetOpen}
          handleClose={handlePwResetClose}
        />
      )}
    </>
  );
};
